module.exports = __webpack_public_path__ + "img/salazar-romero-logo.31d1a4e1.jpg";